export const NEW_MESSAGE_BUTTON_WIDTH = 146;

export const NEW_MESSAGE_BUTTON_WIDTH_NEXT = 174;
